import { defineStore } from 'pinia';
import { ref } from 'vue';
import { http } from '../services/http';
import { IDashboard } from '../services/api/dashboard/types';
import { getLibraryDashboards, getLibraryWidgets } from '../services/api/library/libraryApi';
import { ILibraryDashboard, ILibraryWidget } from '../services/api/library/types';
import { copyDashboard } from '../services/api/dashboard/dashboardApi';

export const useLibraryStore = defineStore('library', () => {
    const widgets = ref<ILibraryWidget[]>([]);
    const dashboards = ref<ILibraryDashboard[]>([]);
    const categories = ref<any[]>([]);
    const page = ref<'widget' | 'dashboard'>('widget');

    const searchFilter = ref<string>('');

    const getWidgets = async () => {
        try {
            const res = await getLibraryWidgets();
            widgets.value = res.widgets;
        } catch (error) {
            console.error('Error fetching library widgets:', error);
        }
    };

    const getDashboards = async () => {
        try {
            const res = await getLibraryDashboards();
            dashboards.value = res.dashboards;
        } catch (error) {
            console.error('Error fetching library dashboards:', error);
        }
    };

    const getCategories = () => {
        http.get('/api/library/categories').then((response) => {
            categories.value = response.data;
        });
    };

    const updateSearchFilter = (search: string) => {
        searchFilter.value = search;
    };

    const addLibraryDashboard = async (dashboard: IDashboard) => {
        const res = await copyDashboard({ title: dashboard.title, dashboardId: dashboard.id });
        return res;
    };

    return {
        categories,
        widgets,
        dashboards,
        searchFilter,
        page,
        getCategories,
        updateSearchFilter,
        getWidgets,
        getDashboards,
        addLibraryDashboard,
    };
});
